import { render, staticRenderFns } from "./Costi-dei-servizi-extra.vue?vue&type=template&id=e60951e6&scoped=true&"
import script from "./Costi-dei-servizi-extra.vue?vue&type=script&lang=js&"
export * from "./Costi-dei-servizi-extra.vue?vue&type=script&lang=js&"
import style0 from "./Costi-dei-servizi-extra.vue?vue&type=style&index=0&id=e60951e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60951e6",
  null
  
)

export default component.exports